import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5026db40"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "images" }, null, -1))
const _hoisted_2 = [
  _hoisted_1
]

import { ref, watch } from "vue"
import config from "@/modules/appConfig"
import { useMapStore } from "@/store/modules/map"


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const mapStore = useMapStore()
const options = ref()
const currentBaseMapIndex = ref(-1)
watch(
  () => mapStore.loading2dFinish,
  (value) => {
    if (value) {
      options.value = config.baseMap
      change()
    }
  }
)
watch(
  () => mapStore.mapType,
  () => {
    options.value = config.activeView.type === "2d" ? config.baseMap : config.base3dMap
    currentBaseMapIndex.value = -1
    change()
  }
)

// 改变底图
const change = () => {
  if (options.value.length && options.value.length > 1) {
    let crntIndex = currentBaseMapIndex.value + 1
    if (crntIndex === options.value.length) {
      crntIndex = 0
    }
    currentBaseMapIndex.value = crntIndex
    options.value.forEach((ele: any, i: number) => {
      const visible = i === crntIndex
      const { children } = ele

      children.forEach((item: any) => {
        const layer = config.getLayer(item.id)
        if (layer) {
          layer.visible = visible
        }
      })
    })
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: "tool-item",
      onClick: change
    }, _hoisted_2)
  ]))
}
}

})